import { inject, Injectable } from '@angular/core'
import { _numberEnumKeyOrUndefined } from '@naturalcycles/js-lib'
import {
  BackendResponseFMResp,
  CancelOrderInput,
  cookieService,
  Order,
  OrderInput,
  PaymentGate,
  PaymentMethodInput,
  WebSignupQueryParam,
} from '@naturalcycles/shared'
import { api } from '@src/app/core/services/api.service.js'
import { CartService } from '@src/app/core/services/cart.service.js'
import { SignalStore } from '@src/app/core/store/signalStore.js'
import { MixpanelEvent } from '@src/app/shared/typings/analytics.js'
import { ReplaySubject } from 'rxjs'
import { AnalyticsService } from './analytics/analytics.service.js'
import { MixpanelService } from './analytics/mixpanel.service.js'
import { SentryService } from './sentry.service.js'

@Injectable({ providedIn: 'root' })
export class OrderService {
  public redDotNonce$ = new ReplaySubject<string>()
  private store = inject(SignalStore)
  private cartService = inject(CartService)
  private sentryService = inject(SentryService)
  private mixpanelService = inject(MixpanelService)
  private analyticsService = inject(AnalyticsService)

  getOrderInput(method?: PaymentMethodInput): OrderInput {
    const { cart } = this.store.getState()
    const utms = this.analyticsService.getAllUtms()

    return {
      method,
      items: this.cartService.getCartItemInputs(),
      discount: this.cartService.getDiscount(),
      hwId: cart.hwId,
      irclickid: cookieService.getCookie(WebSignupQueryParam.irclickid),
      utms,
    }
  }

  async placeOrder(input: OrderInput): Promise<Order> {
    this.sentryService.addBreadcrumb({
      type: 'debug',
      category: 'payment',
      message: 'Place Order',
      data: input,
    })

    void this.mixpanelService.trackEvent(MixpanelEvent.OrderPlaced, {
      lastPaymentGate: _numberEnumKeyOrUndefined(
        PaymentGate,
        this.store.$account().lastPaymentGate,
      ),
      paymentMethod: input.method?.type,
      items: input.items.map(i => i.key),
    })

    const { backendResponse } = await api.post<BackendResponseFMResp>('orders', { json: input })
    return backendResponse.order!
  }

  public async cancelOrder(json: CancelOrderInput): Promise<void> {
    await api.post<BackendResponseFMResp>('orders/cancel', {
      json,
    })
  }
}
